import React from 'react';
import { useTranslation } from "react-i18next";

// icon paths for the listing categories, by their name in the config
export const CATEGORY_ICONS = {
    sale: 'M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8ZM7.5 7.5h.01',
    rent: 'M14 10a4 4 0 1 0-7.4 2.1L3 15.7V20h4.3l.7-.7V18h1.3l.7-.7V16h1.3l1.6-1.6A4 4 0 0 0 14 10ZM10 9h.01',
    short_term: 'M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M5 7h14a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1ZM9 11v5M15 11v5',
};

export const CategoryIcon = ({ name, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={CATEGORY_ICONS[name]} /></svg>
);

// icon paths and description keys for the property types, by their id on the server
export const PROPERTY_TYPES = {
    1: { desc: 'house_desc', icon: 'M3 21h18M5 21V10l7-6 7 6v11M9 21v-6h6v6' },
    2: { desc: 'apartment_desc', icon: 'M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16M15 10h4a1 1 0 0 1 1 1v10M3 21h18M8 8h3M8 12h3M8 16h3' },
    3: { desc: 'garage_desc', icon: 'M5 17h14M6 17l1.5-6h9L18 17M7 17v2M17 17v2M8.5 14h.01M15.5 14h.01M4 10l8-6 8 6' },
};
// short-term rentals only take houses and apartments
export const TYPES_BY_CATEGORY = { short_term: [1, 2] };
// the order the types are offered in: apartment, house, garage; types not listed go last
const TYPE_ORDER = [2, 1, 3];
const typeRank = (id) => TYPE_ORDER.includes(id) ? TYPE_ORDER.indexOf(id) : TYPE_ORDER.length;
export const sortTypes = (types) => [...types].sort((a, b) => typeRank(a.id) - typeRank(b.id));

export const PropertyTypeIcon = ({ id, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={PROPERTY_TYPES[id]?.icon || PROPERTY_TYPES[2].icon} /></svg>
);

const TIPS = [
    { key: 'success_info_1', icon: 'M3 8a2 2 0 0 1 2-2h2l1.5-2h7L17 6h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2ZM12 9.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z' },
    { key: 'success_info_2', icon: 'M4 6h16M4 10h16M4 14h10M4 18h7' },
    { key: 'success_info_3', icon: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 7v5l3 2', warn: true },
];

// the three reminders about photos, the description and listings without photos
export const ListingTips = ({ plain }) => {
    const { t } = useTranslation(["listing"]);

    return (
        <div className={`hs-nl-tips ${plain ? 'plain' : ''}`}>
            {TIPS.map(tip => (
                <div key={tip.key} className='hs-nl-tip'>
                    <span className={`hs-nl-tip-icon ${tip.warn ? 'warn' : ''}`}>
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d={tip.icon} /></svg>
                    </span>
                    <span className='hs-nl-tip-text'>{t(`${tip.key}_part_1`)} <strong>{t(`${tip.key}_part_2`)}.</strong></span>
                </div>
            ))}
        </div>
    );
};
